import { render, staticRenderFns } from "./ProductMetaFilterGroups.vue?vue&type=template&id=9bc9906e"
import script from "./ProductMetaFilterGroups.vue?vue&type=script&lang=js"
export * from "./ProductMetaFilterGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports